import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

export default (<Route
  key="holiday"
  path="holiday"
  lazy={async () => ({
    Component: (await import(
      /* webpackChunkName: 'marketplace' */
      '../components/discovery/holiday_sale_grid'
    )).HolidaySaleGrid,
  })}
/>);
